import type { FC } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ScheduleTimeForm from '@wix/da-submit-shared/pkg/common/ScheduleTimeForm';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import { DiscountFormField } from '../../../types';

interface Props {
  className?: string;
}

const ONE_WEEK_SEC = 7 * 24 * 60 * 60;

const EndTimeInput: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { control, errors, setValue } = useFormContext();
  const error = errors[DiscountFormField.EndTimestamp];
  const {
    field: { onChange },
  } = useController({
    name: DiscountFormField.EndTimestamp,
    control,
    rules: {
      required: true,
    },
  });

  const startTimestamp = useWatch<number>({
    name: DiscountFormField.StartTimestamp,
    control,
  });

  const endTimestamp = useWatch<number>({
    name: DiscountFormField.EndTimestamp,
    control,
  });

  useEffect(() => {
    if (
      typeof startTimestamp === 'number' &&
      typeof endTimestamp === 'number' &&
      startTimestamp >= endTimestamp
    ) {
      const newEnd = startTimestamp + ONE_WEEK_SEC;
      setValue(DiscountFormField.EndTimestamp, newEnd, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [startTimestamp, endTimestamp, setValue]);

  return (
    <ScheduleTimeForm
      initialTime={endTimestamp}
      fieldClassName={className}
      fieldGap={24}
      onChange={ts => ts && onChange(ts)}
      dateInputLabel={t('studio.discountModal.form.endTimeInput.date.label')}
      timeInputLabel={t('studio.discountModal.form.endTimeInput.time.label')}
      noBottomSpacing={false}
      errorMessage={error?.message}
      isRequired
      dropDirection="up"
    />
  );
};
EndTimeInput.displayName = 'EndTimeInput';

export default EndTimeInput;
